import { CommonUtility } from '@utility/common';
import { MathUtility } from '@utility/math';

export const calculatePublicTotal = items => {
  const total = {
    cartons: 0,
    units: 0,
    retails: 0,
    supplierValue: 0,
    grossWeight: 0,
  };
  items?.forEach(item => {
    let latestAttribute = item.attributes;
    const isMultiple = CommonUtility.isValidArray(item.aliases);

    if (isMultiple) {
      let perItemUnits = 0;
      item.aliases.forEach(aliasItem => {
        latestAttribute = aliasItem.attributes;
        const units = aliasItem.qty;
        const ctns = aliasItem.qty / latestAttribute.units_per_carton;

        if (ctns) {
          total.cartons += ctns;
          total.units += +units || 0;
          perItemUnits += +units || 0;
          total.grossWeight += ctns * latestAttribute.carton_gross_weight.value;
        }
      });
      total.retails += (perItemUnits || 0) * (item.price || 0);
      total.supplierValue +=
        (perItemUnits || 0) * (item.supplierItemCost || item.supplierComponentCost || 0);
    } else if (item.qty && latestAttribute) {
      const cartons = (item.qty || 0) / (latestAttribute.units_per_carton || 1);
      total.cartons += cartons;
      total.units += +item.qty || 0;
      total.retails += (+item.qty || 0) * (item.price || 0);
      total.supplierValue +=
        (+item.qty || 0) * (item.supplierItemCost || item.supplierComponentCost || 0);
      total.grossWeight += cartons * latestAttribute.carton_gross_weight?.value;
    }
  });
  return total;
};

export const calculatePublicCBM = items => {
  let tempCBM = 0;
  items?.forEach(item => {
    if (item.qty) {
      let latestAttribute = item.attributes || {};
      const isMultiple = CommonUtility.isValidArray(item.aliases);
      if (isMultiple) {
        item.aliases.forEach(aliasItem => {
          latestAttribute = aliasItem.attributes;
          const ctns = aliasItem.qty / latestAttribute.units_per_carton;
          let calc = 0;
          if (ctns) {
            if (latestAttribute.carton_length?.unit === 'inch') {
              calc = MathUtility.cbf(latestAttribute, ctns);
            } else {
              calc = MathUtility.cbm(latestAttribute, ctns);
            }
          }
          tempCBM += calc;
        });
      } else {
        let calc = 0;
        if (latestAttribute.carton_length?.unit === 'inch') {
          calc = MathUtility.cbf(
            latestAttribute,
            item.qty / (latestAttribute?.units_per_carton || 0),
          );
        } else {
          calc = MathUtility.cbm(
            latestAttribute,
            item.qty / (latestAttribute?.units_per_carton || 0),
          );
        }
        tempCBM += calc;
      }
    }
  });
  return tempCBM || 0;
};
